import dynamic from 'next/dynamic';

import useSWRImmutable from 'swr/immutable';

import { DiagramComponentInstance, DiagramConnection } from 'models';

import { useCurrentUser } from 'hooks/use-current-user';
import { ProjectService } from 'services/ProjectService';

const DiagramPreview = dynamic(() => import('@diagram/components/diagram-preview/DiagramPreview'), { ssr: false });

const ProjectTeaserPreview = ({
    projectId,
    isVisible,
    containerWidth,
}: {
    projectId: string;
    isVisible: boolean;
    containerWidth?: number;
}) => {
    const user = useCurrentUser();

    const { data: teaserData, isLoading } = useSWRImmutable(
        user && isVisible ? `/api/projects/${projectId}/teaser` : null,
        () => ProjectService.getTeaser(projectId),
        { keepPreviousData: true },
    );

    const componentInstances = Object.values(
        teaserData?.diagram?.componentInstances || {},
    ) as DiagramComponentInstance[];
    const connections = Object.values(teaserData?.diagram?.connections || {}) as DiagramConnection[];

    return (
        <DiagramPreview
            emptyMessage={isLoading ? 'Loading preview...' : 'Empty diagram'}
            componentInstances={componentInstances}
            connections={connections}
            maxWidth={containerWidth || undefined}
            maxHeight={containerWidth ? (containerWidth * 9) / 16 : undefined}
        />
    );
};

export { ProjectTeaserPreview };
